import { render } from "./AccountDefaults.vue?vue&type=template&id=6de222d1&scoped=true"
import script from "./AccountDefaults.vue?vue&type=script&lang=js"
export * from "./AccountDefaults.vue?vue&type=script&lang=js"

import "./AccountDefaults.vue?vue&type=style&index=0&id=6de222d1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6de222d1"]])

export default __exports__